const rubricSelectors = {
    editingRubricId: state => state.rubric?.editingRubricId,
    editingCategoryId: state => state.rubric?.editingCategoryId,
    showCreateRubricDrawer: state => state.rubric?.showCreateRubricDrawer,
    showCreateCategoryDrawer: state => state.rubric?.showCreateCategoryDrawer,
}

export default rubricSelectors
